export enum EProgressBarStep {
  AD_PROVIDERS = 'AD_PROVIDERS',
  INVITED_MEMBERS = 'INVITED_MEMBERS',
  FACEBOOK_PROFILES = 'FACEBOOK_PROFILES',
  STORE_WORKFLOWS = 'STORE_WORKFLOWS',
}
